import { LabelModelType } from '@teinor/erp/types/company/config/label'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'

export interface LabelsAction {
    type: 'CHANGE_LABELS'
    payload: LabelModelType[] | null
}

export type LabelsPayload = { [id: number]: LabelModelType } | null

export default function labels(state: LabelsPayload = null, action: LabelsAction): LabelsPayload | null {
    switch (action.type) {
        case 'CHANGE_LABELS':
            const mylabels = dictionaryComplexFromJsonArr(action.payload || [])
            return state = {...mylabels}
        default:
            return state
    }
}